// extracted by mini-css-extract-plugin
export var searchHeader = "_n-0";
export var searchHeaderDark = "_n-1";